import demandReducer from "./demand/demandReducer";
import annualProcurementPlanReducer from "./annualProcurementPlan/annualProcurementReducer";
import vendorReducer from "./vendor/vendorReducer";
import procurementReducer from "./procurement/procurementReducer";
import tenderNoticePublicationReducer from "./procurement/tenderNoticePublicationReducer";
import NOAReducer from "./procurement/NOAReducer";

import agreementReducer from "./procurement/agreementReducer";
import committeeReducer from "./committee/committeeReducer";
import packageReducer from "./package/packageReducer";

const procurementsReducers = {
  committeeState: committeeReducer,
  demandState: demandReducer,
  annualProcurementPlanState: annualProcurementPlanReducer,
  vendorState: vendorReducer,
  procurementState: procurementReducer,
  tenderNoticePublicationState: tenderNoticePublicationReducer,
  noaState: NOAReducer,
  agreementState: agreementReducer,
  packageState: packageReducer,
};

export default procurementsReducers;
